<template>
  <div>
    <section class="sectionStyle" style="background-color: #e5ebff;padding: 120px 0;">
      <img src="../../assets/imgs/shapes/shape-11.png" class="KCJS_bg" alt="">
      <img src="../../assets/imgs/shapes/shape-10.png" class="KCJS_bg_bian float-bob-y" style="left: 0;" alt="">
      <img src="../../assets/imgs/shapes/shape-9.png" class="KCJS_bg_bian float-bob-y" style="right: 0;top: 50%;" alt="">
      <div class="GS_JJ_content_box">
        <div class="ck_header">
          <a-row class="GS_JJ_content_box "  type="flex" justify="space-between">
            <a-col :xs="24" :sm="24" :md="24" :lg="20" class="animate__animated animate__fadeInLeftBig wow">
              <p class="modular_title">精选课程 <span style="font-size:32px;font-weight:400">Courses</span> </p>
            </a-col>
            <a-col  :xs="24" :sm="24" class="fixed-width-md">
              <div class="swiperButton">
                <div class="swiper-button-prev swiper-button-white swiper-button-prev-jxkc" slot="button-prev"><a-icon type="left" /></div>
                <div class="swiper-button-next swiper-button-white swiper-button-next-jxkc" slot="button-next"><a-icon type="right" /></div>
              </div>
            </a-col>
          </a-row>
        </div>
        <swiper ref="mySwiperKc" :options="swiperOptionsjxkc" style="height: 480px;" class="swiper-wrappe carousel">
              <swiper-slide class="swiper-slide"  v-for="(b,i) in list" :key="i">
                 <div class="kc_list_box">
                  <div class="ck_img"> <img :src="b.courseCover_url" alt=""></div>
                  <div class="ck_info">
                    <!-- <div class="ck_icon_box">
                      <img :src="b.courseIcon_url" alt="">
                    </div> -->
                    <h4 class="title">{{ b.courseName }}</h4>
                    <p class="content">{{ b.courseDesc }}</p>
                    <p class="moreText" @click="goDeatilsFn(b)">更多内容<a-icon type="double-right" /></p>
                  </div>
                 </div>
              </swiper-slide>
        </swiper>
      </div>
    </section>
  </div>
</template>
<script>
import { getAction } from "@/api/manage";
export default {
  props:[],
  watch:{},
  name: '',
  components: {},
  data() {
    return {
    // 课程介绍
    swiperOptionsjxkc:{
        autoplay:false,
        speed: 800,
        observer: true,
        observeParents: true,
        slidesPerView: 3, // 大于900像素时显示3个幻灯片
        spaceBetween: 20,  // 可选：设置间距
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next-jxkc",
          prevEl: ".swiper-button-prev-jxkc",
        },
        loop: true,
        breakpoints: {
          920: {  //当屏幕宽度小于等于1280
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {  //当屏幕宽度小于等于768
            slidesPerView: 1,
            spaceBetween: 20,
          },
        } 
      },
      list:[]
    }
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo
    this.init()
  },
  mounted() {},
  methods: {
    init(){
      getAction("/teaching/teachingCourse/showCourse", {
        column: 'orderNum',
        order: 'desc',
        courseType: '',
        pageSize: 999,
      }).then((res) => {
        if (res.success) {
            this.list = res.result.records
        }
      });
    },
    goDeatilsFn(b){
      console.log(b , 'bbb')
      this.$router.push({
        path: '/course/detail',
        query: {
          id: b.id,
        },
      })
    }
  }
}
</script>
<style lang='less' scoped>
.modular_title{
  width: 100%;
  text-align: left;
  font-weight: 600;
  font-size: 48px;
  color: #000000;
  line-height: 75px;
}
.swiper-button-prev-jxkc , .swiper-button-next-jxkc{
  color:#0039C8;
  border-color: #0039C8;
}
</style>
